import script from "./VTableTrTotal.vue?vue&type=script&setup=true&lang=js"
export * from "./VTableTrTotal.vue?vue&type=script&setup=true&lang=js"

import "./VTableTrTotal.vue?vue&type=style&index=0&id=68789ce6&scoped=true&lang=less"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68789ce6"]])

export default __exports__